import React from 'react';
import PropTypes from 'prop-types';
import {
  Time,
  UserName,
  UserImage,
  UserBanner,
  UserNameWrapper,
} from './PinnedPostCard.styled';
import Avatar from '../../../../../../containers/User/Avatar/Avatar';
import formatDate from '../../../../../../../../core/utils/formatDate';

const Banner = ({ user, time }) => (
  <UserBanner>
    <UserImage>
      <Avatar user={user} size={24} isInstructor />
    </UserImage>
    <UserNameWrapper>
      <UserName>{`${user.firstName} ${user.lastName}`}</UserName>
      <Time>
        <span>{formatDate(time)}</span>
      </Time>
    </UserNameWrapper>
  </UserBanner>
);

Banner.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    avatar: PropTypes.string,
  }).isRequired,
  time: PropTypes.string.isRequired,
};

export default Banner;
